<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:05:09
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的考证</div>
    <div class="my-content">
      <div class="my-search-box">
        <el-select
          v-model="getListData.CertTypeID"
          placeholder="选择证书"
          clearable
          @change="getList"
        >
          <el-option
            v-for="(it, i) in certificateTypeList"
            :key="i"
            :label="it.label"
            :value="it.value"
          />
        </el-select>
        <div class="my-dateRange">
          <el-date-picker
            v-model="getListData.StartDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="考试开始时间"
          >
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker
            v-model="getListData.EndDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="考试结束时间"
          >
          </el-date-picker>
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="CertName" label="证书分类" align="left">
          <template slot-scope="scope">
            {{ scope.row.CertName }} ({{ scope.row.CertLevel }})
          </template>
        </el-table-column>
        <el-table-column
          prop="ExamStartTime"
          label="考试开始时间"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ExamEndTime"
          label="考试结束时间"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="ExamResultTxt" label="考试结果" align="center">
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { CertType_GetList, GetMyExamCertList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "myCert",
  data() {
    return {
      certificateTypeList: [], //证书类型
      isLoading: false,
      total: 0,
      tableData: [],
      getListData: {
        CertTypeID: "",
        PageIndex: 1,
        PageSize: 10,
        StartDate: "",
        EndDate: "",
      },
    };
  },
  mounted() {
    this.getClassifyList();
    this.getList();
  },
  methods: {
    getClassifyList() {
      CertType_GetList().then((res) => {
        this.certificateTypeList = res.data.map((item) => {
          return {
            label: item.CertName + "(" + item.CertLevel + ")",
            value: item.CertTypeID,
          };
        });
      });
    },
    getList() {
      this.isLoading = true;
      const data = {
        ...this.getListData,
      };
      GetMyExamCertList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-search-box {
  .my-search {
    width: 251px;
  }
  .el-select {
    ::v-deep .el-input__inner {
      width: 251px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }
  .el-date-editor {
    width: 180px;
    height: 47px;
    ::v-deep .el-input__inner {
      width: 180px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }
}
.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.bmName {
  font-size: 20px;
  color: #333333;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.time {
  margin-top: 5px;
  font-size: 16px;
  color: #666666;
}
.StatusID {
  font-size: 16px;
  color: #1d79ff;
}
.my-form {
  .mt-form-item {
    margin-bottom: 20px;
    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }
    .must {
      color: #ef3d3d;
    }
  }
  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
}
.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
